import { Component, OnInit, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../../Utils/_services/admin/admin/admin.service';

import { CALC_REGEX } from '@primeuix/themes';
import { ToastrService } from 'ngx-toastr';
import { SpinnerLoaderComponent } from '../../../../shared/components/spinner-loader/spinner-loader.component';
import { ConfirmService } from '../../../../Utils/_services/confirmation-dialog.service';
import { IUserActivity, IUserDetails } from '../../../../Utils/_models/users.model';



@Component({
  selector: 'app-user-detail',
  standalone: true,
  imports: [CommonModule, DatePipe,SpinnerLoaderComponent],
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css'],
})
export class UserDetailComponent implements OnInit {
user: IUserDetails | null = null;
activities: IUserActivity[] = [];
userId : string | null = null;
loader = signal(false);
isBanLoading = signal(false);
isDeleteLoading = signal(false);
  constructor(private router: Router,
    private route: ActivatedRoute,
    private adminService: AdminService,
   private toastr: ToastrService,
   private confirmService: ConfirmService,) { }

  ngOnInit(): void { 

     this.route.paramMap.subscribe(params => {
    this.userId = params.get('id');

    if (this.userId) {
      this.getUserDetails(this.userId);
    }
  });
  }

getUserDetails(userId: string) {
  this.loader.set(true);
  this.adminService.getUserDetails(userId).subscribe({
    next: ({ data }) => {
      console.log(data, "user");
      this.user = data?.user ?? null;
      this.activities = data?.activities ?? [];
         this.loader.set(false);
    },
    error: () => {
        this.loader.set(false);
      this.user = null;
      this.activities = [];
    }
  });
}

async toggleUserStatus() {
  if (!this.user?.id) return;

  const currentStatus = this.user.status;
  const isBanning = currentStatus === 'Active';
  const actionText = isBanning ? 'Ban' : 'Unban';

  const confirmed = await this.confirmService.confirmAction(
    `${actionText} User`,
    `Are you sure you want to ${actionText.toLowerCase()} this user?`
  );

  if (!confirmed) return;

  this.isBanLoading.set(true);

  this.adminService.banUser(this.user.id).subscribe({
    next: res => {
      this.isBanLoading.set(false);

      if (res.auth.success) {
        if (!this.user) return;

        this.user.status =
          currentStatus === 'Active' ? 'Banned' : 'Active';

        this.toastr.success(res.msg || res.data.message, 'Success');
      } else {
        this.toastr.error(res.msg, 'Error');
      }
    },
    error: err => {
      this.isBanLoading.set(false);
      console.error(err);
      this.toastr.error('Something went wrong', 'Error');
    }
  });
}
async deleteUser() {
  if (!this.user?.id) return;

  const confirmed = await this.confirmService.confirmDelete('user');
  if (!confirmed) return;

  this.isDeleteLoading.set(true);

  this.adminService.deleteUsers([this.user.id]).subscribe({
    next: res => {
      this.isDeleteLoading.set(false);

      if (res.auth.success) {
        this.toastr.success(res.msg, 'Success');
        this.router.navigate(['/admin/users']);
      } else {
        this.toastr.error(res.msg, 'Error');
      }
    },
    error: () => {
      this.isDeleteLoading.set(false);
      this.toastr.error('Something went wrong', 'Error');
    }
  });
}
  goBack(): void {
    this.router.navigate(['/admin/users']);
  }
}
